export default {
  en: {
    stopVoiceAria: 'Stop voice: {{name}}',
    playVoiceAria: 'Play voice: {{name}}',
    accentAmerican: 'American',
    accentBritish: 'British',
    accentGerman: 'German',
    accentBrazilian: 'Brazilian',
  },
  ru: {
    stopVoiceAria: 'Остановить голос: {{name}}',
    playVoiceAria: 'Послушать голос: {{name}}',
    accentAmerican: 'Американский',
    accentBritish: 'Британский',
    accentGerman: 'Немецкий',
    accentBrazilian: 'Бразильский',
  },
  de: {
    stopVoiceAria: 'Stimme stoppen: {{name}}',
    playVoiceAria: 'Stimme abspielen: {{name}}',
    accentAmerican: 'Amerikanisch',
    accentBritish: 'Britisch',
    accentGerman: 'Deutsch',
    accentBrazilian: 'Brasilianisch',
  },
  pt: {
    stopVoiceAria: 'Parar voz: {{name}}',
    playVoiceAria: 'Ouvir voz: {{name}}',
    accentAmerican: 'Americano',
    accentBritish: 'Britânico',
    accentGerman: 'Alemão',
    accentBrazilian: 'Brasileiro',
  },
  fr: {
    stopVoiceAria: 'Arrêter la voix : {{name}}',
    playVoiceAria: 'Écouter la voix : {{name}}',
    accentAmerican: 'Américain',
    accentBritish: 'Britannique',
    accentGerman: 'Allemand',
    accentBrazilian: 'Brésilien',
  },
  es: {
    stopVoiceAria: 'Detener la voz: {{name}}',
    playVoiceAria: 'Escuchar la voz: {{name}}',
    accentAmerican: 'Estadounidense',
    accentBritish: 'Británico',
    accentGerman: 'Alemán',
    accentBrazilian: 'Brasileño',
  },
};
